<div class="file-item-row" (click)="toggle()" [class.directory]="item.type === 'DIRECTORY'">
  <div class="file-item-cell name">
    <div [style.flex-shrink]="0" [style.width.px]="depth * 20"></div>
    @if (item.type !== 'DIRECTORY') {
      <span class="file-icon-placeholder"></span>
      <span class="file-icon">📄</span>
    }
    @if (item.type === 'DIRECTORY') {
      <span class="expand-icon" [class.expanded]="expanded"></span>
      <span class="file-icon">📁</span>
    }
    <span class="text-truncate">{{ item.path }}</span>
  </div>
  <div class="file-item-cell size">{{ formatSize(item.size) }}</div>
  <div class="file-item-cell relative">{{ getRelativePercentage() }}</div>
  <div class="file-item-cell date">{{ item.modifiedAt | date:'yyyy-MM-dd HH:mm:ss' }}</div>
</div>

@if (expanded) {
  <div class="children-container">
    @if (loading) {
      <div class="loading-spinner" [style.padding-left.px]="(depth + 1) * 20">
        Loading...
      </div>
    }
    @for (child of children; track child.id) {
      <app-file-scan-item
        [scanUid]="scanUid"
        [item]="child"
        [depth]="depth + 1"
        [sortConfig]="sortConfig"
        [parentSize]="item.size"
      ></app-file-scan-item>
    }
  </div>
}
